import heightModelValidator from 'forms/shared/validators/models/height/height';

import { eyeColorOptions, hairColorOptions, sexOptions } from 'constants/enums/physicalOptions';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { IdentificationPhysicalModel } from './types';

const identificationPhysicalValidator: ValidateJSModel<IdentificationPhysicalModel> = {
  Height: (value, attributes, attributeName, options) => {
    if (options?.requireIdentificationPhysicalHeight) { return { presence: true, model: { validator: heightModelValidator } }; }

    return {};
  },

  // Value can accept string, which is weird, as we want this to be numbers
  // only.
  Weight: (value, attributes, attributeName, options) => {
    if (options?.requireIdentificationPhysicalWeight) {
      return {
        presence: true,
        hasValue: {
          validator: {
            numericality: {
              onlyInteger: true,
              greaterThanOrEqualTo: 10,
              lessThanOrEqualTo: 999,
              notGreaterThanOrEqualTo: 'error.weight.min',
              notLessThanOrEqualTo: 'error.weight.max',
              notInteger: 'error.weight.pattern',
            },
          },
        },
      };
    }

    return {};
  },

  HairColor: (value, attributes, attributeName, options) => {
    if (options?.requireIdentificationPhysicalHairColor) {
      return {
        presence: true,
        hasValue: {
          validator: { inclusion: { within: hairColorOptions, message: 'error.inclusion' } },
        },
      };
    }

    return {};
  },

  EyeColor: (value, attributes, attributeName, options) => {
    if (options?.requireIdentificationPhysicalEyeColor) {
      return {
        presence: true,
        hasValue: {
          validator: { inclusion: { within: eyeColorOptions, message: 'error.inclusion' } },
        },
      };
    }

    return {};
  },

  Sex: {
    presence: true,
    hasValue: { validator: { inclusion: { within: sexOptions, message: 'error.inclusion' } } },
  },

  Comments: {},
};

export default identificationPhysicalValidator;
